import styles from './ListItem.module.scss';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { FunctionComponent } from 'react';

interface ListItemProps {
    label: string;
    selected: boolean;
    disabled?: boolean;
    description?: string;
    className?: string;
    onClick?: (selected: boolean) => void;
}

export const ListItem: FunctionComponent<ListItemProps> = props => {
    const clickHandler = () => {
        if (props.disabled) {
            return;
        }
        props.onClick?.(!props.selected);
    };

    return (
        <div
            className={clsx(styles.container, props.className, { [styles.disabled]: props.disabled })}
            onClick={clickHandler}
        >
            <span className={styles.checkboxSlot}>
                {!props.disabled && (
                    <FontAwesomeIcon
                        icon={props.selected ? faSquareCheck : faSquare}
                        fontSize={18}
                    />
                )}
            </span>
            <div className={styles.content}>
                <span className={styles.label}>{props.label}</span>
                {props.description && <span className={styles.description}>{props.description}</span>}
            </div>
        </div>
    );
};

export default ListItem;
